export default {"root":"AmbXU","sm":"n0klQ"};